import React from 'react';
import styled from 'styled-components';
import ShadowCard from '../ShadowCard';

/**
 * 白色卡片
 * @param {Object} props
 * @param {React.ReactNode} props.footer 底部
 * @param {*} props.children
 * @returns
 */
export default function Panel({ children, footer, ...others }) {
  return (
    <Root className='as-panel narrow-scrollbar' footer={footer} {...others}>
      {children}
    </Root>
  );
}

const Root = styled(ShadowCard)`
  min-height: 100%;
`;
